import React, { Fragment, useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import "./ProductDetail.scss";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductDetail } from "../../Redux/slices/productSlice";
import Loader from "../../Components/Loader/Loader";
import Swal from "sweetalert2";
import { setCartOpen } from "../../Redux/slices/appConfigSlice";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

function ProductDetails() {
  const params = useParams();
  const id = params.id;

  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.app);
  const { product, productDefaultPrice } = useSelector(
    (state) => state.products
  );
  const [price, setPrice] = useState("");
  const [weight, setWeight] = useState("");
  const [isAddedOnCart, setIsAddedOnCart] = useState(false);
  const images = product?.images;

  // if(!isLoading){
  //   if (product) {
  //     setPrice(product.weightPrice[0]?.price);
  //     setWeight(product.weightPrice[0]?.weight);
  //   }
  // }

  //Carousel Code
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images?.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const handleSelectPrice = (info) => {
    const itemPrice = product?.weightPrice?.find(
      (price) => price.id === info.id
    );
    setPrice(itemPrice?.price);
    setWeight(itemPrice?.weight);
  };

  useEffect(() => {
    dispatch(getProductDetail({ id }));
  }, [dispatch, id]);

  //For Default Price
  useEffect(() => {
    if (productDefaultPrice) {
      setWeight(productDefaultPrice.weight);
      setPrice(productDefaultPrice.price);
    }
  }, [productDefaultPrice]);

  const addToCart = () => {
    if (!price.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select a price",
      });
    } else {
      dispatch({
        type: "ProductSlice/addToCart",
        payload: { id: product._id, price, weight },
      });
      setIsAddedOnCart(true);
    }
  };

  return (
    <Fragment>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="ProductDetail">
          <div className="container product__detail-container">
            <Box sx={{ maxWidth: 400, flexGrow: 1 }}>
              <AutoPlaySwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
              >
                {images?.map((step, index) => (
                  <div key={step._id}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <Box
                        component="img"
                        sx={{
                          height: 255,
                          display: "block",
                          maxWidth: 400,
                          overflow: "hidden",
                          width: "100%",
                        }}
                        src={step.url}
                        alt={step._id}
                      />
                    ) : null}
                  </div>
                ))}
              </AutoPlaySwipeableViews>
              <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowLeft />
                    ) : (
                      <KeyboardArrowRight />
                    )}
                  </Button>
                }
                backButton={
                  <Button
                    size="small"
                    onClick={handleBack}
                    disabled={activeStep === 0}
                  >
                    {theme.direction === "rtl" ? (
                      <KeyboardArrowRight />
                    ) : (
                      <KeyboardArrowLeft />
                    )}
                  </Button>
                }
              />
            </Box>

            <div className="product__details">
              <p>{product?.category}</p>
              <h3>{product?.name}</h3>
              <div className="product__sm-desc">
                <p className="p-text">{product?.description}</p>
              </div>

              <div className="weight__badge">
                {product?.weightPrice?.map((weight, i) => (
                  <span
                    onClick={() => handleSelectPrice(weight)}
                    className="active-badge"
                  >
                    {weight.weight}
                  </span>
                ))}
              </div>

              <div className="prize">
                <p>₹{price}</p>
              </div>

              <div className="submit__btn">
                {!isAddedOnCart ? (
                  <button onClick={() => addToCart()} className="btn">
                    Add To Cart
                  </button>
                ) : (
                  <button onClick={() => dispatch(setCartOpen(true))} className="btn">
                    Go To Cart
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="product__About-container">
            <div className="product__desc">
              <h3>Product Description</h3>
              <p className="p-text">{product?.longDescription}</p>
            </div>
            <br></br>
          </div>
        </div>
      )}
    </Fragment>
  );
}

export default ProductDetails;
